import HttpClientToken from '../../services/HttpClientToken';

import { defaultSubEtapa, SubEtapaProps } from '../../interfaces/catalogos/SubEtapaInterface';

export const SubEtapas = () => {

    return new Promise<SubEtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SubEtapa/', token)
            .then( ({ data } : { data : SubEtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerSubEtapas = () => {

    return new Promise<SubEtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SubEtapa/ObtenerSubEtapas', token)
            .then( ({ data } : { data : SubEtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerSubEtapa = ( id: number ) => {

    return new Promise<SubEtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/SubEtapa/ObtenerSubEtapa/${ id }`, token)
            .then( ({ data } : { data : SubEtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ActualizarSubEtapa = ( params: SubEtapaProps ) => {

    return new Promise<SubEtapaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SubEtapa/Actualizar', params, token)
            .then( ({ data } : { data : SubEtapaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSubEtapa } );
            });

        }

    });

}

export const AgregarSubEtapa = ( params: SubEtapaProps ) => {

    return new Promise<SubEtapaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SubEtapa/Agregar', params, token)
            .then( ({ data } : { data : SubEtapaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSubEtapa } );
            });

        }

    });

}
